import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import { useIncomingInvoiceReminders } from "@/hooks/use-incoming-invoice-reminders";
import { columns } from "./table-config";

/**
 * Every reminder the organisation received, newest first — the ones matched to their invoice and,
 * so none is lost, the ones no invoice matched.
 */
export function IncomingInvoiceReminders() {
	/** Query */
	const { reminders, isLoading, queryKey, refetch } = useIncomingInvoiceReminders();

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={reminders}
				columns={columns}
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				menu={null}
				persistenceKey="incoming-invoice-reminders-table"
			/>
		</ContentBox>
	);
}
